import { useEffect, useState } from 'react';
import { MainStore, useMainStore } from '../stores/mainStore';
import { HubPost } from './HubPost';

export const Hub = () => {
  const hubPosts = useMainStore((state: MainStore) => state.hubPosts);
  const hubLoading = useMainStore((state: MainStore) => state.hubLoading);
  const [, setTimeUpdate] = useState(0); // Force update for time display

  useEffect(() => {
    // Update time display every minute
    const interval = setInterval(() => {
      setTimeUpdate((prev) => prev + 1);
    }, 60000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="app-container1 flex flex-col flex-grow overflow-auto pb-8">
      {hubPosts.map((post) => (
        <HubPost key={post._id} postId={post._id} />
      ))}
      {hubLoading && (
        <div className="flex justify-center p-4">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 dark:border-white"></div>
        </div>
      )}
    </div>
  );
};
